import { createAction } from 'redux-actions';
import { createAsyncActions } from '@wahaaabello/redux-async-actions';

const [logInRequest, logInSuccess, logInFailure] = createAsyncActions('LOG_IN');

const [registerRequest, registerSuccess, registerFailure] = createAsyncActions('REGISTER');

const logOut = createAction('LOG_OUT');
const sessionCountDown = createAction('SESSION_COUNTDOWN');

const authActions = {
  logInRequest,
  logInSuccess,
  logInFailure,
  registerRequest,
  registerSuccess,
  registerFailure,
  logOut,
  sessionCountDown,
};

export default authActions;
